export const SOCKET_ENDPOINT = "https://tic-tac-toe-67a4.onrender.com" // 'http://localhost:3003';
